import React, { useState } from 'react';
import { BaseConfigProps, commonStyles } from '../shared/ConfigFormHelpers';
import CollapsibleSection from '../shared/CollapsibleSection';

const TelegramMessageConfig: React.FC<BaseConfigProps> = ({ node, updateConfig }) => {
  const [expandedSections, setExpandedSections] = useState<Set<string>>(new Set(['message']));
  
  const toggleSection = (section: string) => {
    setExpandedSections(prev => {
      const newSet = new Set(prev);
      if (newSet.has(section)) {
        newSet.delete(section);
      } else {
        newSet.add(section);
      }
      return newSet;
    });
  };

  return (
    <div className="space-y-3">
      {/* Üzenet Tartalom */}
      <CollapsibleSection
        id="message"
        title="Telegram Üzenet"
        icon="💬"
        color="blue"
        isExpanded={expandedSections.has('message')}
        onToggle={toggleSection}
      >
        <div className="space-y-3">
          <div>
            <label className={commonStyles.smallLabel}>
              Chat ID
            </label>
            <input
              type="text"
              value={node.data.config.chatId || ''}
              onChange={(e) => updateConfig('chatId', e.target.value)}
              className={commonStyles.input}
              placeholder="@channel_name vagy -1001234567890"
            />
            <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
              Csoport/csatorna ID vagy @username
            </p>
          </div>

          <div>
            <label className={commonStyles.smallLabel}>
              Üzenet
            </label>
            <textarea
              value={node.data.config.message || ''}
              onChange={(e) => updateConfig('message', e.target.value)}
              rows={4}
              className={commonStyles.textarea}
              placeholder="Telegram üzenet szövege..."
            />
            <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
              HTML formázás támogatott. Változók: {`{{név}}`}
            </p>
          </div>

          <div>
            <label className={commonStyles.smallLabel}>
              Parse Mode
            </label>
            <select
              value={node.data.config.parseMode || 'HTML'}
              onChange={(e) => updateConfig('parseMode', e.target.value)}
              className={commonStyles.select}
            >
              <option value="HTML">HTML</option>
              <option value="Markdown">Markdown</option>
              <option value="">Nincs formázás</option>
            </select>
          </div>
        </div>
      </CollapsibleSection>

      {/* Bot Konfiguráció */}
      <CollapsibleSection
        id="bot"
        title="Bot Beállítások"
        icon="🤖"
        color="indigo"
        isExpanded={expandedSections.has('bot')}
        onToggle={toggleSection}
      >
        <div>
          <label className={commonStyles.smallLabel}>
            Bot Token
          </label>
          <input
            type="password"
            value={node.data.config.botToken || ''}
            onChange={(e) => updateConfig('botToken', e.target.value)}
            className={commonStyles.input}
            placeholder="1234567890:ABCdefGHIjklMNOpqrsTUVwxyz"
          />
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
            @BotFather-től kapott bot token
          </p>
        </div>
      </CollapsibleSection>
    </div>
  );
};

export default TelegramMessageConfig;
